import { Box, Stack, Typography } from "@mui/material";

export default function LoginStreakRewardsSettings({ rawData }) {
	if (!rawData) {
		return (
			<Typography color="error" variant="body2">
				Invalid or empty JSON data
			</Typography>
		);
	}
	return (
		<Stack spacing={1} sx={{ p: 2, pt: 1, flex: 1, justifyContent: "center" }}>
			<Stack direction="row" spacing={{ xs: 0.5, sm: 0.8 }} alignItems="center" justifyContent="center" flexWrap="wrap">
				{rawData.map((row) => (
					<Box
						key={row.day}
						sx={{
							width: 35,
							height: 35,
							borderRadius: "50%",
							backgroundColor: "primary.main",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							color: "white",
							fontWeight: "bold",
							fontSize: "0.9rem",
							boxShadow: 2,
							flexShrink: 0,
							aspectRatio: "1",
						}}
					>
						{row.amount}
					</Box>
				))}
			</Stack>
		</Stack>
	);
}
